// extracted by mini-css-extract-plugin
export var root = "nGkj";
export var rootHeading = "tfKK";
export var rootIcon = "P34j";
export var rootIconWrapper = "rAAJ";
export var rootImage = "Sywn";
export var rootItems = "Pq7f";
export var rootItemsWrapper = "vtE6";
export var rootPicture = "_2hYx";